import { Box, Typography } from "@mui/material";
import React from "react";
import logo from '../../assets/logo.svg';
import ring_loader_blue from '../../assets/ring_loader_blue.gif';
import load from '../../assets/load.webp';

const MountPageLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: '500px',
        backgroundColor: "#FFFFFF",
        // background: "linear-gradient(180deg, #33A0DA -414.65%, #FFFFFF 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated background circles */}
      <Box
        sx={{
          position: "absolute",
          width: "460px",
          height: "460px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(0, 119, 181, 0.1) 0%, transparent 70%)",
          animation: "pulse 3s ease-in-out infinite",
          "@keyframes pulse": {
            "0%, 100%": {
              transform: "scale(1)",
              opacity: 0.5,
            },
            "50%": {
              transform: "scale(1.2)",
              opacity: 0.8,
            },
          },
        }}
      />

      {/* Logo container with animation */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          animation: "fadeInUp 1s ease-out",
          "@keyframes fadeInUp": {
            "0%": {
              opacity: 0,
              transform: "translateY(20px)",
            },
            "100%": {
              opacity: 1,
              transform: "translateY(0)",
            },
          },
        }}
      >
        <Box
          sx={{
            mb: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          {/* Rotating ring around logo */}
          <Box
            sx={{
              position: "absolute",
              width: "140px",
              height: "140px",
              border: "3px solid transparent",
              borderTopColor: "#009ab5ff",
              borderRightColor: "#0ba1b1ff",
              borderRadius: "50%",
              animation: "rotate 1.5s linear infinite",
              "@keyframes rotate": {
                "0%": {
                  transform: "rotate(0deg)",
                },
                "100%": {
                  transform: "rotate(360deg)",
                },
              },
            }}
          />

          {/* Secondary rotating ring */}
          <Box
            sx={{
              position: "absolute",
              width: "160px",
              height: "160px",
              border: "2px solid transparent",
              borderBottomColor: "#33A0DA",
              borderLeftColor: "#33A0DA",
              borderRadius: "50%",
              animation: "rotateReverse 2s linear infinite",
              "@keyframes rotateReverse": {
                "0%": {
                  transform: "rotate(0deg)",
                },
                "100%": {
                  transform: "rotate(-360deg)",
                },
              },
            }}
          />

          {/* Logo */}
          <Box
            sx={{
              width: "92px",
              height: "92px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
              borderRadius: "50%",
              boxShadow: "0px 8px 24px rgba(0, 119, 181, 0.2)",
              padding: "16px",
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {/* Loading dots */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            mt: 4,
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "#0077B5",
                animation: "bounce 1.4s ease-in-out infinite",
                animationDelay: `${index * 0.2}s`,
                "@keyframes bounce": {
                  "0%, 80%, 100%": {
                    transform: "scale(0.8)",
                    opacity: 0.5,
                  },
                  "40%": {
                    transform: "scale(1.2)",
                    opacity: 1,
                  },
                },
              }}
            />
          ))}
        </Box>

        {/* Loading text */}
        <Box
          sx={{
            mt: 3,
            textAlign: "center",
          }}
        >
          <Box
            component="span"
            sx={{
              fontFamily: "Lato",
              fontSize: "16px",
              fontWeight: 500,
              color: "#0077B5",
              letterSpacing: "1px",
              animation: "fadeText 2s ease-in-out infinite",
              "@keyframes fadeText": {
                "0%, 100%": {
                  opacity: 0.6,
                },
                "50%": {
                  opacity: 1,
                },
              },
            }}
          >
            Loading...
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MountPageLoader;
